import Config from './roles.router';
import options from './roles.component';
import UACRoleUsers from './role-users';

const Component = {
    selector: 'dtRolesView',
    options
};

export {
    Config,
    Component,
    UACRoleUsers
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/roles/index.js